import { useState, lazy, Suspense } from 'react';

import Content from 'src/componentes/pages/content';
import Legenda from 'src/componentes/legenda/legenda-acao';
import LoadingScreen from 'src/componentes/LoadingScreen';
import { useHistory } from 'react-router';
import qs from 'query-string';

const GanttView = lazy(() => import('./View.js'));

const Container = (props = {}) => {
  const history = useHistory();
  const { location } = history || {};
  const [urlProps] = useState({
    showBackButton: location && qs.parse(location.search).showBackButton,
  });

  const [title, setTitle] = useState('');

  const [componentKey, setComponentKey] = useState(1);
  const [componentView, setComponentView] = useState(null);
  const [filter, setFilter] = useState({});
  const [showLegend, setShowLegend] = useState(true);

  const {
    ehApresentacao,
    showBackButton = false,
    confirmarSincronizacaoAutomatica = false,
  } = props;

  const handleChangeFieldFilter = (field, value) => {
    setFilter((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const updateTree = () => setComponentKey((prev) => prev + 1);

  const renderContent = () => (
    <div
      className="d-flex flex-column"
      style={{ minHeight: 'calc(-180px + 99vh)' }}
    >
      <div style={{ flex: 1, minHeight: 0 }}>
        <Suspense fallback={<LoadingScreen />}>
          <GanttView
            handleCloseModal={props.handleCloseModal}
            key={componentKey}
            filter={filter}
            handleChangeFieldFilter={handleChangeFieldFilter}
            updateTree={updateTree}
            componentView={componentView}
            setComponentView={setComponentView}
            handleChangePageTitle={setTitle}
            showLegend={showLegend}
            onToggleLegend={() => setShowLegend((prev) => !prev)}
            {...props}
            confirmarSincronizacaoAutomatica={confirmarSincronizacaoAutomatica}
          />
        </Suspense>
      </div>
      {showLegend && (
        <div className="d-flex justify-content-center mt-2">
          <Legenda />
        </div>
      )}
    </div>
  );

  return ehApresentacao ? (
    renderContent()
  ) : (
    <Content isEllipsis titulo={title} showBackButton={showBackButton || urlProps?.showBackButton}>
      {renderContent()}
    </Content>
  );
};

export default Container;
